import { render, staticRenderFns } from "./Giveaways.vue?vue&type=template&id=3f347486&"
import script from "./Giveaways.vue?vue&type=script&lang=js&"
export * from "./Giveaways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports